const ReportHwEntity = {
    idSiswa: null,
    idKelasParalel: null,
    usernameSiswa: null,
    namaSiswa: null,
    namaMapel: null,
    skor: null,
    lamaPengerjaan: null,
    namaProfil: null,
    kodeTa: null
}

export default ReportHwEntity;